/*
 * Copyright © 2025 EC Studios Ltd.
 * All rights reserved
 */

import React from 'react';
import { IconButton, Tooltip, Badge } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import {useReports} from '../../status/StatusContext';
import { useHasPermission } from '../../permission/PermissionUtil';
import { useNavigate } from 'react-router-dom';

const squareHighlightStyle = {
    width: '45px',
    height: '45px',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '0',
    padding: '0',
};

export default function PlayerReportButton() {

    const navigate = useNavigate();

    const openReports = () => {
        navigate("/player/report");
    };

    const hasViewReportsPermission = useHasPermission("Player:Report:View");
    const reportsCount = useReports();

    if (!hasViewReportsPermission) {
        return null;
    }

    return (
        <IconButton
            size="large"
            type='button'
            onClick={openReports}
            color="inherit"
            style={squareHighlightStyle}
        >
            <Badge badgeContent={reportsCount} color="warning">
                <Tooltip title='Unreviewed Reports'>
                    <WarningIcon />
                </Tooltip>
            </Badge>
        </IconButton>
    );
}
